<input
  type="file"
  class="file-input"
  #fileUpload
  (change)="uploadFile(fileUpload.files)"
  style="display: none;"
/>
<!-- (change)="onFileSelected($event)" -->

  <!-- <span class="upload" *ngIf="message">
    {{ filename }}
  </span> -->
  <!-- <span class="upload" *ngIf="progress > 0"> {{ progress }}% </span>
  <span class="upload" *ngIf="message">
    {{ message }}
  </span> -->
  <!-- <div class="col-md-4">  
</div> -->
<button
  type="button"
  mat-icon-button
  color="primary"
  aria-label="adjuntar"
  matTooltip="Adjuntar documento"
  (click)="fileUpload.click()"
>
  <mat-icon>folder</mat-icon>
</button>

<button
  type="button"
  mat-icon-button
  color="primary"
  aria-label="remover"
  matTooltip="Eliminar documento"
  (click)="removerDocumentoSeleccionado()"
  >
  <mat-icon>delete</mat-icon>
</button>
